import { styled } from '@ringcentral/juno';

export const Container = styled.div`
  width: 240px;
`;
